module.exports = __webpack_public_path__ + "static/media/pdf.a8a8a447.jpeg";